let currentBannerRedirectUrl = ''
// 获取当前页面完整路径（包含查询参数和hash)
  function getCurrentPath() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  // 解析规则字符串为对象数组
  function parseRules(ruleString) {
    try {
      return JSON.parse(ruleString);
    } catch (e) {
      return [];
    }
  }
  
  // 检查URL是否匹配规则
  function matchesRule(path, rules) {
    // if (!rules || rules.length === 0) return false;
    if(rules === null) return true;
    return rules.some(rule => {
      const { type, value } = rule;
      switch (type) {
        case 'contains':
          return path.includes(value);
        case 'equals':
          return path === value;
        default:
          console.warn('未知的规则类型:', type);
          return false;
      }
    });
  }

  function toBackToSchool (){
    window.open(currentBannerRedirectUrl, '_blank')
  }
  
  // 判断banner是否应该显示
  function shouldShowBanner(banner) {
    const currentPath = getCurrentPath();
    // 解析显示和隐藏规则
    const showRules = parseRules(banner.show_rule);
    const hideRules = parseRules(banner.hide_rule);
    // 检查是否匹配显示规则
    const matchesShow = matchesRule(currentPath, showRules);
    // 检查是否匹配隐藏规则,hideRules为null时，其实是未设置，未设置就是默认显示，那hideRules的值应该为false
    const matchesHide = hideRules === null? false: matchesRule(currentPath, hideRules);
    // 最终结果：显示规则为true AND 隐藏规则为false
    return matchesShow && !matchesHide;
  }

// 转换为多伦多时区的函数
function convertToLosAngelesTime(date) {
  return new Date(date.toLocaleString('en-US', { timeZone: 'America/Toronto' }));
}

// 转换为多伦多时区的时间
function formatterTime (date) {
    const formatter = date.toLocaleString('en-US', {
      timeZone: 'America/Toronto',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })

    return formatter.replace(/24:/, '00:')
  }

  // new Date()获取的时间后转换成 2025-07-31T07:00:00Z这种时间格式
  function cstToUtcIso(cstTimeString) {
    const date = new Date(cstTimeString);
    return date.toISOString().replace(/\.\d+Z$/, 'Z');
  }

// 判断是否在洛杉矶时区的时间范围内
function isInLosAngelesTimeRange(banner) {
  const now = new Date();
  const nowTime = formatterTime((new Date(cstToUtcIso(now).replace('Z', ''))).getTime()); // 获取系统时间
  const startTime = formatterTime((new Date(banner.countdown_starts_at.replace('Z', ''))).getTime()); 
  const endTime = formatterTime((new Date(banner.countdown_ends_at.replace('Z', ''))).getTime());
  return nowTime >= startTime && nowTime <= endTime;
}

// 检查用户是否在7天内关闭过banner
function isBannerClosedByUser() {
    return document.cookie.split(';').some(item => item.trim().startsWith('topBannerClosed='));
}

function alignTopBannerWithHeader() {
  if (window.innerWidth <= 990) {
    return; // 直接返回，不执行对齐逻辑
  }
  const headerLogo = document.querySelector('.header__logo-link');
  const topBannerLeft = document.querySelector('.top-banner__left');
  console.log('headerLogo', headerLogo.offsetLeft);
  if (headerLogo && topBannerLeft) {
    const rect = headerLogo.getBoundingClientRect();
    const leftDistance = rect.left;
    topBannerLeft.style.marginLeft = leftDistance + 'px';
  }
}



document.addEventListener('DOMContentLoaded', function() {
  const bannerData = window.bannerData || [];
  let isShowBanner = false
  // 这里是调试先注释掉，因为匹配路径匹配不到不展示bannner
 const activeBanner = bannerData.find(banner => {
   return isInLosAngelesTimeRange(banner) && shouldShowBanner(banner);
 });
  const topBanner = document.querySelector('.top-banner');
  // 检查用户是否在7天内关闭过banner
  if (isBannerClosedByUser()) {
    
    if (topBanner) {
      topBanner.style.display = 'none';
    }
  }else{
  currentBannerRedirectUrl = activeBanner?.redirect_url || '';
  if (!activeBanner) {
    // 如果没有匹配的banner，隐藏整个top-banner
    // const topBanner = document.querySelector('.top-banner');
    if (topBanner) {
      topBanner.style.display = 'none';
    }
  }else{
    if (topBanner) {
      topBanner.style.display = 'block';
      isShowBanner = true
    }
  }
  }
  // 获取banner数据
  
    // const unitityBar = document.querySelector('.utility-bar');
    if (isShowBanner) {
      closeTopBanner('info');
    } else {
      closeTopBanner();
    }

  // 更新banner内容
  if(activeBanner){
    alignTopBannerWithHeader();
    updateBannerContent(activeBanner);
  
    // 启动倒计时
    startCountdown(activeBanner);
  }
  
});

// 更新banner内容
function updateBannerContent(banner) {
  const bannerElement = document.querySelector('.top-banner');
  // 根据屏幕尺寸选择背景图
  if (window.innerWidth <= 990) {
    // 移动端：优先使用 mobile 背景图，
    const mobileBgUrl = banner.background_image_cdn_url_mobile;
    const bgUrl = mobileBgUrl; 
     
    
    if (bgUrl) {
      bannerElement.style.backgroundImage = `url(${bgUrl})`;
    }
  } else{
    if (banner.background_image_cdn_url) {
      bannerElement.style.backgroundImage = `url(${banner.background_image_cdn_url})`;
    }
  }
  
  // const bannerElement = document.querySelector('.top-banner');
  // if (banner.background_image_cdn_url) {
  //   bannerElement.style.backgroundImage = `url(${banner.background_image_cdn_url})`;
  // }
  
  const titleElement = document.querySelector('.top-banner__title');
  if (titleElement && banner.description_text) {
    titleElement.textContent = banner.description_text;
  }
  
  const subtitleElement = document.querySelector('.top-banner__subtitle');
  if (subtitleElement && banner.title_text) {
    subtitleElement.textContent = banner.title_text;
  }
  
  const countdownElement = document.querySelector('.top-banner__countdown');
  if (countdownElement && banner.countdown_starts_at && banner.countdown_ends_at) {
    countdownElement.setAttribute('data-start-date', banner.countdown_starts_at);
    countdownElement.setAttribute('data-end-date', banner.countdown_ends_at);
  }
}

// 添加窗口大小变化监听
window.addEventListener('resize', function() {
  // 重新获取当前活跃的banner
  const bannerData = window.bannerData || [];
  const activeBanner = bannerData.find(banner => {
    return isInLosAngelesTimeRange(banner) && shouldShowBanner(banner);
  });
  
  if (activeBanner) {
    updateBannerContent(activeBanner);
    alignTopBannerWithHeader();
  }
});

// 启动倒计时
function startCountdown(banner) {
  const countdownElement = document.querySelector('.top-banner__countdown');
  if (!countdownElement) return;

  // 获取开始和结束时间
  const startDateStr = countdownElement.getAttribute('data-start-date');
  const endDateStr = countdownElement.getAttribute('data-end-date');
  
  if (!startDateStr || !endDateStr) return;
  
  const startDate = convertToLosAngelesTime(new Date(startDateStr));
  const endDate = convertToLosAngelesTime(new Date(endDateStr));
  
  // 计算总倒计时时间（结束时间 - 开始时间）
  const totalDuration = endDate - startDate;
  
  function updateCountdown() {
    const currentDate = convertToLosAngelesTime(new Date());
    
    // 计算已经过去的时间（当前时间 - 开始时间）
    const elapsedTime = currentDate - startDate;
    
    // 计算剩余时间（总时间 - 已经过去的时间）
    const remainingTime = totalDuration - elapsedTime;
    
    if (remainingTime <= 0) {
      // 倒计时结束，隐藏banner
      const topBanner = document.querySelector('.top-banner');
      if (topBanner) {
        topBanner.style.display = 'none';
        closeTopBanner();
      }
      return;
    }
    
    // 新增：检查是否小于7天
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
    if (remainingTime > sevenDaysInMs) {
      // 大于7天，隐藏倒计时
      countdownElement.style.display = 'none';
      return;
    } else {
      // 小于等于7天，显示倒计时
      countdownElement.style.display = 'flex';
    }
  
    // 计算天、时、分、秒
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
  
    // 更新显示
    const daysElement = countdownElement.querySelector('.countdown-days');
    const hoursElement = countdownElement.querySelector('.countdown-hours');
    const minutesElement = countdownElement.querySelector('.countdown-minutes');
    const secondsElement = countdownElement.querySelector('.countdown-seconds');
  
    if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
    if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
    if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
    if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
  }
  
  // 立即更新一次
  updateCountdown();
  
  // 每秒更新一次
  setInterval(updateCountdown, 1000);
}

// 关闭banner
  function hideTopBanner(event) {
    if(event) {
        event.stopPropagation()
    }
    
    closeTopBanner();
    setBannerClosedCookie();
  }

function closeTopBanner(type) {
    const topBanner = document.querySelector('.top-banner');
    const unitityBar = document.querySelector('.utility-bar');
    const leHeader = document.querySelector('.le-header');
    const headerWrap = document.querySelector('.header-wrapper');
    const navPopupSection = document.querySelector('.nav-popup-section');
    const navPopupBackground = document.querySelector('.nav-popup-background');
    const lerpoAccountDialog = document.querySelector('.lepro-account-dialog');
    if (topBanner) {
        if (type == 'info') {
          topBanner.style.display = 'block';
        } else {
          topBanner.style.display = 'none';
        }
        // le-header 是 fixed 定位，promo-bar 在普通流中
        // padding-bottom 为导航栏高度，保证内容不被 fixed 导航遮住
        if (headerWrap) headerWrap.style.paddingBottom = leHeader.offsetHeight + 'px';
        // 触发全局位置同步（promo-bar.liquid 中定义），更新导航 top 及弹出层位置
        if (typeof window.syncLeHeaderPosition === 'function') {
          window.syncLeHeaderPosition();
        } else {
          navPopupSection.style.top = leHeader.offsetHeight +'px';
          navPopupBackground.style.top = leHeader.offsetHeight +'px';
          lerpoAccountDialog.style.top = leHeader.offsetHeight-10 +'px';
        }
    }
}

// 设置cookie有效期7天，用于记录用户是否关闭过banner
function setBannerClosedCookie() {
    var d = new Date();
    d.setTime(d.getTime() + (7*24*60*60*1000)); // 7天
    let expires = "expires=" + d.toUTCString();
    document.cookie = "topBannerClosed=true;" + expires + ";path=/";
  }

  function isBannerClosedByCookie() {
    return document.cookie.split(';').some(item => item.trim().startsWith('topBannerClosed='));
  }
